import wcwidth from "@topcli/wcwidth";

interface ReplaceCommaValuesOptions {
  /** 只回傳指定的鍵值(keys) */
  exclusive?: boolean;
}

const defaultReplaceCommaValuesOptions: ReplaceCommaValuesOptions = {
  exclusive: false,
};

export const StringHelper = {
  replaceBreakLineValues<T, K extends keyof T>(
    obj: T,
    keys: Array<T[K] extends string ? K : never>
  ) {
    const newObj = keys.reduce((acc, key) => {
      const newValue = (obj[key] as string).replaceAll("\n", ",");
      return {
        ...acc,
        [key]: newValue,
      };
    }, obj);

    return newObj;
  },
  replaceCommaValues<T, K extends keyof T>(
    obj: T,
    keys: Array<T[K] extends string ? K : never>,
    options?: ReplaceCommaValuesOptions
  ) {
    const opts = Object.assign({}, defaultReplaceCommaValuesOptions, options);

    const newObj = keys.reduce(
      (acc, key) => {
        const newValue = (obj[key] as string).replaceAll(",", "\n");
        return {
          ...acc,
          [key]: newValue,
        };
      },
      opts.exclusive ? ({} as T) : obj
    );

    return newObj;
  },
  getLength(text: string) {
    return wcwidth(text);
  },
  cutString(text: string, size: number) {
    let result = "";
    for (let index = 0; index < text.length; index++) {
      if (wcwidth(text.slice(0, index)) > size) {
        break;
      }
      result = text.slice(0, index);
    }
    return result;
  },
  ellipsisMiddle(text: string, size: number) {
    if (wcwidth(text) <= size) {
      return text;
    }
    var result = "...";
    var prefix = "";
    var suffix = "";
    var length = text.length;
    for (var i = 0; i < length; i++) {
      if (wcwidth(prefix) <= wcwidth(suffix)) {
        prefix += text.charAt(i);
      }
      var temp = `${prefix}...${suffix}`;
      if (wcwidth(temp) > size) {
        break;
      }
      result = temp;
      if (wcwidth(prefix) > wcwidth(suffix)) {
        suffix += text.charAt(length - 1 - i);
      }
      var temp = `${prefix}...${suffix}`;
      if (wcwidth(temp) > size) {
        break;
      }
      result = temp;
    }
    return result;
  },
  ellipsisEnd(text: string, size: number) {
    if (wcwidth(text) <= size) {
      return text;
    }
    var result = "";
    for (var i = 0; i < text.length; i++) {
      var temp = `${text.slice(0, text.length - i)}...`;
      if (wcwidth(temp) <= size) {
        break;
      }
      result = temp;
    }
    return result;
  },
};
